import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Divider,
    Grid2,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Stack,
    Step,
    StepLabel,
    Stepper,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    useGetCourseDetailMutation,
    useGetCourseDetailsListByIdMutation,
    useGetCourseSubDetailMutation,
    useGetCourseTrackListMutation,
} from "../../../apiSlice";
import { API_courseURL } from "../../../config";
import SideBar from "./TeacherSidebar/TeacherSidebar";
import Navbar from "../../Header/header";

import Loader from "../../Loader";
import Breadcrumb from "../../StudentBreadcrumb/Breadcrumb";
import "./Course.css";
import certificate from "./certificate.png";
import difficulty from "./difficulty.png";
import duration from "./duration.png";
import enrolled from "./enrolled.png";
import modify from "./modify.png";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            className="panelCover"
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const StudentCourseDetails = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [courseData] = useState(() =>
        JSON.parse(sessionStorage.getItem("courseData") || "{}")
    );
    const [userID] = useState(() => JSON.parse(localStorage.getItem("UserID")));
    const [courseSubDetails, setCourseSubDetails] = useState([]);
    const [courseDetails, setCourseDetails] = useState([]);
    const [courseTrackData, setCourseTrackData] = useState([]);
    const [startOrResume, setStartOrResume] = useState(true);
    const [activeStep, setActiveStep] = useState(0);
    const [value, setValue] = useState(0);
    const [dense] = useState(false);

    const steps = useMemo(() => ["0%", "25%", "50%", "75%", "100%"], []);

    const [studentCourseSubDetailsAPI] = useGetCourseSubDetailMutation();
    const [studentCourseDetailAPI] = useGetCourseDetailMutation();
    const [studentCourseDetailListByIdAPI] =
        useGetCourseDetailsListByIdMutation();
    const [studentCourseTrackListAPI] = useGetCourseTrackListMutation();

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const courseSubD = await studentCourseSubDetailsAPI();
            const filteredCourseSubDetails =
                courseSubD?.data?.filter(
                    (e) => e.courseId === courseData.courseId
                ) || [];
            setCourseSubDetails(filteredCourseSubDetails);

            const courseD = await studentCourseDetailListByIdAPI(
                String(courseData.courseId)
            );

            // const filteredCourseDetails =
            //     courseD?.data
            //         ?.filter((e) => e.courseId === courseData.courseId)
            //         .slice()
            //         .reverse() || [];

            const filteredCourseDetails = courseD?.data.slice().reverse() || [];

            setCourseDetails(filteredCourseDetails);

            const courseT = await studentCourseTrackListAPI();
            const filteredCourseTrack =
                courseT?.data?.filter(
                    (e) =>
                        e.courseId === courseData.courseId &&
                        e.userID === userID
                ) || [];
            setCourseTrackData(filteredCourseTrack);

            setStartOrResume(filteredCourseTrack.length === 0);
        } catch (error) {
            console.error("Error fetching course data:", error);
        } finally {
            setLoading(false);
        }
    }, [
        courseData.courseId,
        userID,
        studentCourseSubDetailsAPI,
        studentCourseDetailAPI,
        studentCourseTrackListAPI,
    ]);

    useEffect(() => {
        if (
            courseDetails.length === 0 &&
            courseSubDetails.length === 0 &&
            courseTrackData.length === 0
        ) {
            fetchData();
        }
    }, [
        fetchData,
        courseDetails.length,
        courseSubDetails.length,
        courseTrackData.length,
    ]);

    const courseTotalModule = useMemo(
        () => courseDetails.length,
        [courseDetails]
    );
    const courseProgress = useMemo(
        () =>
            startOrResume
                ? 0
                : courseTrackData?.filter((e) => e.courseCompleted === true)
                      .length,
        [startOrResume, courseTrackData]
    );
    const percentCompleted = useMemo(
        () => (startOrResume ? 0 : (courseProgress * 100) / courseTotalModule),
        [startOrResume, courseProgress, courseTotalModule]
    );

    useEffect(() => {
        let newStep = 0;
        if (percentCompleted === 100) {
            newStep = 4;
        } else if (percentCompleted > 75) {
            newStep = 3;
        } else if (percentCompleted > 50) {
            newStep = 2;
        } else if (percentCompleted > 25) {
            newStep = 1;
        }
        setActiveStep(newStep);
    }, [percentCompleted]);

    const handleTabChange = useCallback((event, newValue) => {
        setValue(newValue);
    }, []);

    const handleStartLearning = useCallback(() => {
        navigate("/TeacherCourseContent");
    }, [navigate]);

    if (loading) {
        return (
            <div className="container-scroller">
                <Navbar />
                <div className="container-fluid page-body-wrapper">
                    <SideBar />
                    <div className="main-panel">
                        <Box
                            sx={{
                                padding: "20px",
                                height: "calc(100vh - 60px)",
                                backgroundColor: "#F8F9FD",
                            }}
                        >
                            <Breadcrumb />
                            <Loader />
                        </Box>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container-scroller">
            <Navbar />
            <div className="container-fluid page-body-wrapper">
                <SideBar />
                <div className="main-panel">
                    <Box
                        sx={{
                            width: "100%",
                            padding: "20px",
                            height: "calc(100vh - 60px)",
                            overflowY: "scroll",
                            backgroundColor: "#F8F9FD",
                        }}
                    >
                        <Breadcrumb />
                        <Grid2 container spacing={4}>
                            <Grid2
                                size={8}
                                container
                                direction="column"
                                spacing={2}
                                className="courseLeft"
                            >
                                <Typography
                                    variant="h4"
                                    sx={{ color: "text.primary" }}
                                >
                                    {courseData.courseName}
                                </Typography>
                                <Box>
                                    <div className="heroDiv">
                                        <img
                                            src={
                                                API_courseURL +
                                                courseData.courseThumbnailImagepath
                                            }
                                            alt="Course thumbnail"
                                        />
                                    </div>
                                </Box>

                                <Box sx={{ width: "100%" }}>
                                    <Box
                                        sx={{
                                            borderBottom: 1,
                                            borderColor: "divider",
                                        }}
                                    >
                                        <Tabs
                                            value={value}
                                            onChange={handleTabChange}
                                            aria-label="basic tabs example"
                                            textColor="secondary"
                                            indicatorColor="secondary"
                                        >
                                            <Tab
                                                label="Course Info"
                                                {...a11yProps(0)}
                                            />
                                            <Tab
                                                label="Q&A"
                                                {...a11yProps(1)}
                                            />
                                            <Tab
                                                label="Announcements"
                                                {...a11yProps(2)}
                                            />
                                            <Tab
                                                label="Gradebook"
                                                {...a11yProps(3)}
                                            />
                                        </Tabs>
                                    </Box>

                                    <CustomTabPanel value={value} index={0}>
                                        <Grid2 container spacing={2}>
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    background: "#ffffff",
                                                    padding: "20px",
                                                    borderRadius: "6px",
                                                }}
                                            >
                                                <Typography variant="h5">
                                                    About Course
                                                </Typography>
                                                <Divider
                                                    sx={{ paddingTop: "20px" }}
                                                />
                                                <div
                                                    style={{
                                                        marginTop: "30px",
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: courseData.aboutUs,
                                                    }}
                                                />
                                            </Box>

                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    background: "#ffffff",
                                                    padding: "20px",
                                                    borderRadius: "6px",
                                                }}
                                            >
                                                <Typography variant="h5">
                                                    What Will You Learn?
                                                </Typography>
                                                <Divider
                                                    sx={{ paddingTop: "20px" }}
                                                />
                                                <div
                                                    style={{
                                                        marginTop: "30px",
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: courseData.whatYouWillLearn,
                                                    }}
                                                />
                                            </Box>

                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    background: "#ffffff",
                                                    padding: "20px",
                                                    borderRadius: "6px",
                                                }}
                                            >
                                                <Typography variant="h5">
                                                    Course Contents
                                                </Typography>
                                                <Divider
                                                    sx={{ paddingTop: "20px" }}
                                                />
                                                <Box
                                                    sx={{
                                                        marginTop: "30px",
                                                        padding: "0 20px",
                                                        background: "#F8F8FA",
                                                        borderRadius: "6px",
                                                    }}
                                                >
                                                    {courseSubDetails
                                                        ?.filter(
                                                            (course) =>
                                                                course.courseId ===
                                                                courseData.courseId
                                                        )
                                                        .slice()
                                                        .reverse()
                                                        .map((entry, index) => (
                                                            <Accordion
                                                                defaultExpanded={
                                                                    index === 0
                                                                }
                                                                key={
                                                                    entry.courseSubdetailsId
                                                                }
                                                                sx={{
                                                                    background:
                                                                        "transparent",
                                                                    boxShadow:
                                                                        "none",
                                                                }}
                                                            >
                                                                <AccordionSummary
                                                                    expandIcon={
                                                                        <ExpandMoreIcon />
                                                                    }
                                                                    aria-controls="panel1-content"
                                                                    id="panel1-header"
                                                                    sx={{
                                                                        padding:
                                                                            "0",
                                                                    }}
                                                                >
                                                                    <Box
                                                                        width={
                                                                            "100%"
                                                                        }
                                                                        display={
                                                                            "flex"
                                                                        }
                                                                        justifyContent={
                                                                            "space-between"
                                                                        }
                                                                    >
                                                                        <Typography component="span">
                                                                            {
                                                                                entry.courseTopicName
                                                                            }
                                                                        </Typography>
                                                                        <Typography component="span">
                                                                            {
                                                                                entry.courseTopicDescription
                                                                            }
                                                                        </Typography>
                                                                    </Box>
                                                                </AccordionSummary>
                                                                <Divider variant="middle" />
                                                                <AccordionDetails>
                                                                    <Grid2 item>
                                                                        <List
                                                                            dense={
                                                                                dense
                                                                            }
                                                                        >
                                                                            {courseDetails
                                                                                ?.filter(
                                                                                    (
                                                                                        e
                                                                                    ) =>
                                                                                        e.courseSubdetailsId ===
                                                                                        entry.courseSubdetailsId
                                                                                )
                                                                                .slice()
                                                                                .map(
                                                                                    (
                                                                                        subEntry
                                                                                    ) => (
                                                                                        <ListItem
                                                                                            key={
                                                                                                subEntry.courseDetailID
                                                                                            }
                                                                                            secondaryAction={
                                                                                                <IconButton
                                                                                                    edge="end"
                                                                                                    aria-label="delete"
                                                                                                ></IconButton>
                                                                                            }
                                                                                        >
                                                                                            <ListItemAvatar>
                                                                                                <PlayCircleFilledWhiteOutlinedIcon />
                                                                                            </ListItemAvatar>
                                                                                            <ListItemText
                                                                                                primary={
                                                                                                    subEntry.courseHeading
                                                                                                }
                                                                                            />
                                                                                        </ListItem>
                                                                                    )
                                                                                )}
                                                                        </List>
                                                                    </Grid2>
                                                                </AccordionDetails>
                                                            </Accordion>
                                                        ))}
                                                </Box>
                                            </Box>
                                        </Grid2>
                                    </CustomTabPanel>

                                    <CustomTabPanel value={value} index={1}>
                                        Q&A
                                    </CustomTabPanel>

                                    <CustomTabPanel value={value} index={2}>
                                        Announcements
                                    </CustomTabPanel>

                                    <CustomTabPanel value={value} index={3}>
                                        Gradebook
                                    </CustomTabPanel>
                                </Box>
                            </Grid2>

                            <Grid2 size={4} className="courseRight">
                                <Grid2
                                    sx={{
                                        width: "100%",
                                        background: "#ffffff",
                                        padding: "20px",
                                        borderRadius: "6px",
                                    }}
                                    container
                                    spacing={3}
                                    direction={"column"}
                                >
                                    <Stack
                                        spacing={1}
                                        sx={{ maxWidth: "100%" }}
                                    >
                                        <Typography variant="h6">
                                            Course Progress
                                        </Typography>
                                        <Typography variant="body1">
                                            {courseProgress}/{courseTotalModule}
                                        </Typography>
                                        {/* <Box
                                            sx={{
                                                padding: "10px 0",
                                                width: "100%",
                                            }}
                                        >
                                            <Stepper
                                                activeStep={activeStep}
                                                alternativeLabel
                                            >
                                                {steps.map((label) => (
                                                    <Step
                                                        key={label}
                                                        sx={{ padding: "0" }}
                                                    >
                                                        <StepLabel>
                                                            {label}
                                                        </StepLabel>
                                                    </Step>
                                                ))}
                                            </Stepper>
                                        </Box> */}
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            sx={{ width: "100%" }}
                                            onClick={handleStartLearning}
                                        >
                                            {startOrResume
                                                ? "Start Learning"
                                                : "Continue Learning"}
                                        </Button>
                                        <Typography
                                            variant="body2"
                                            textAlign={"center"}
                                        >
                                            <ShoppingCartOutlinedIcon
                                                color="success"
                                                fontSize="small"
                                                sx={{ marginRight: "5px" }}
                                            />
                                            You enrolled in this course on
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            textAlign={"center"}
                                            color="success"
                                        >
                                            January 18, 2025
                                        </Typography>
                                    </Stack>

                                    <Divider variant="middle" />

                                    <Stack spacing={2}>
                                        <Typography variant="h6">
                                            This course includes
                                        </Typography>
                                        <Stack
                                            className="courseIncludesStack"
                                            spacing={0.5}
                                        >
                                            <div>
                                                <img
                                                    src={difficulty}
                                                    alt="Difficulty"
                                                />
                                                <Typography variant="body1">
                                                    {
                                                        courseData.courseDifficulty
                                                    }
                                                </Typography>
                                            </div>
                                            <div>
                                                <img
                                                    src={enrolled}
                                                    alt="Enrolled"
                                                />
                                                <Typography variant="body1">
                                                    {} Total Enrolled
                                                </Typography>
                                            </div>
                                            <div>
                                                <img
                                                    src={duration}
                                                    alt="Duration"
                                                />
                                                <Typography variant="body1">
                                                    {courseData.courseDuration}{" "}
                                                    hours Duration
                                                </Typography>
                                            </div>
                                            <div>
                                                <img
                                                    src={modify}
                                                    alt="Modified"
                                                />
                                                <Typography variant="body1">
                                                    {courseData.modifiedDate}{" "}
                                                    Last Updated
                                                </Typography>
                                            </div>
                                            <div>
                                                <img
                                                    src={certificate}
                                                    alt="Certificate"
                                                />
                                                <Typography variant="body1">
                                                    Certificate of Completion
                                                </Typography>
                                            </div>
                                        </Stack>
                                    </Stack>

                                    <Divider variant="middle" />

                                    <Stack spacing={2}>
                                        <Typography variant="h6">
                                            Material Includes
                                        </Typography>
                                        <Stack spacing={1}>
                                            <Typography variant="body1">
                                                Material list for this course:
                                            </Typography>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: courseData.materialInclude,
                                                }}
                                            />
                                        </Stack>
                                    </Stack>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default StudentCourseDetails;
